import * as React from 'react'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import { WithStyles, Theme, createStyles, withStyles} from '@material-ui/core'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import './editor.css'
import autobind from 'autobind-decorator'

const styles = (t: Theme) => createStyles({
   
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>{
  onChange: any;
  value: any;
  readOnly?: boolean;
}

const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }]
    ],
    clipboard: {
      matchVisual: false,
    }
}
  
const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike',  
    'color', 'background',
    'list', 'bullet'
]

class MessageText extends React.Component<IProps, {}> {

  render() {
    const {value, readOnly} = this.props;
    return (
        <ReactQuill 
            className="message-text"
            value={value || ''}
            onChange={this.handleChange} 
            readOnly={readOnly}
            formats={formats} 
            modules={modules} 
        />
    )
  }

  
  @autobind
  private handleChange(values){
      this.props.onChange(values)
  }

}

export default compose(
    withI18n,
    withStyles(styles)
)(MessageText)



// WEBPACK FOOTER //
// ./src/shared/MessageText/MessageText.tsx